import React, { useContext, useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/UserContext";
import UserSettingsAvatar from "./UserSettingsAvatar";
import { USER_SETTINGS_MENU_ITEMS } from "./userSettingsMenu";
import "./CustomLayout.css";

const MobileUserSettingsPanel = ({ onNavigate }) => {
  const { userDetails } = useContext(UserContext);
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const handleItemClick = (href) => {
    navigate(href);
    onNavigate?.();
  };

  return (
    <div className="mobile-user-settings-panel">
      <button
        type="button"
        className="mobile-user-settings-trigger"
        onClick={() => setExpanded((prev) => !prev)}
        aria-expanded={expanded}
      >
        <div className="mobile-user-settings-user">
          <span className="mobile-user-settings-name">
            {userDetails?.first_name} {userDetails?.last_name}
          </span>
          <span className="mobile-user-settings-email">{userDetails?.email}</span>
        </div>
        <UserSettingsAvatar size={40} />
        <DownOutlined
          className={`mobile-user-settings-chevron${
            expanded ? " mobile-user-settings-chevron--open" : ""
          }`}
        />
      </button>

      {expanded ? (
        <div className="mobile-user-settings-menu">
          {USER_SETTINGS_MENU_ITEMS.map(({ key, title, href, Icon }) => (
            <button
              key={key}
              type="button"
              className="mobile-user-settings-item"
              onClick={() => handleItemClick(href)}
            >
              <Icon />
              <span>{title}</span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default MobileUserSettingsPanel;
